export const SEND_BIRD_API_URL = process.env.SEND_BIRD_API_URL || '';
export const SEND_BIRD_APP_ID = process.env.REACT_APP_SEND_BIRD_APP_ID || '';
export const GLOBAL_HANDLER = process.env.REACT_APP_GLOBAL_HANDLER || '';
export const PREVIOUS_CHANNEL_LIMIT = 30;
export const PREVIOUS_MESSAGE_LIMIT = 30;
